import {getLoggedIn} from "@awe-web/shared/lib/user/store.js";
import {redirect} from "@awe-web/shared/lib/routing/actions.js";
import {MyBmwRentDashboard} from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState) => {
  if (getLoggedIn(getState())) {
    dispatch(redirect(MyBmwRentDashboard.location()));
  }
};
